import { useRoutes } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import useDocumentTitle from 'hooks/useDocumentTitle';

export default function Routes() {
    const allRoutes = [MainRoutes];
    useDocumentTitle(allRoutes);

    return useRoutes(allRoutes);
}
